import {    pro6F1Charge,pro6F1Payment,pro6F1Collectable,pro6F1NonCollectable,pro6F1ClaimCount,pro6F1PerVisit,
    pro6F2Charge,pro6F2Payment,pro6F2Collectable,pro6F2NonCollectable,pro6F2ClaimCount,pro6F2PerVisit,
    pro6F3Charge,pro6F3Payment,pro6F3Collectable,pro6F3NonCollectable,pro6F3ClaimCount,pro6F3PerVisit,} from './FacilityData';


import {provider6PerVisist} from './ProvidersAndFacility';



export const pro6WithJan21Charges = [
    pro6F1Charge.jan21,
    pro6F2Charge.jan21,
    pro6F3Charge.jan21,
    pro6F1Charge.jan21 + pro6F2Charge.jan21 + pro6F3Charge.jan21

]
// console.log("pro6WithJan21Charges :",pro6WithJan21Charges)
export const pro6WithJan21Pay = [
    pro6F1Payment.jan21,
    pro6F2Payment.jan21,
    pro6F3Payment.jan21,
    pro6F1Payment.jan21 + pro6F2Payment.jan21 + pro6F3Payment.jan21
]
export const pro6WithJan21Count = [
    pro6F1Collectable.jan21,
    pro6F2Collectable.jan21,
    pro6F3Collectable.jan21,
    pro6F1Collectable.jan21 + pro6F2Collectable.jan21 + pro6F3Collectable.jan21
]
export const pro6WithJan21NonCount = [
    pro6F1NonCollectable.jan21,
    pro6F2NonCollectable.jan21,
    pro6F3NonCollectable.jan21,
    pro6F1NonCollectable.jan21 + pro6F2NonCollectable.jan21 + pro6F3NonCollectable.jan21
]
export const pro6WithJan21Claim = [
    pro6F1ClaimCount.jan21,
    pro6F2ClaimCount.jan21,
    pro6F3ClaimCount.jan21,
    pro6F1ClaimCount.jan21 + pro6F2ClaimCount.jan21 + pro6F3ClaimCount.jan21
]
export const pro6WithJan21PerVisit = [
    pro6F1PerVisit.jan21,
    pro6F2PerVisit.jan21,
    pro6F3PerVisit.jan21,
    provider6PerVisist[0]
]
// feb 21
export const pro6WithFeb21Charges = [
    pro6F1Charge.feb21,
    pro6F2Charge.feb21,
    pro6F3Charge.feb21,
    pro6F1Charge.feb21 + pro6F2Charge.feb21 + pro6F3Charge.feb21
]
export const pro6WithFeb21Pay = [
    pro6F1Payment.feb21,
    pro6F2Payment.feb21,
    pro6F3Payment.feb21,
    pro6F1Payment.feb21 + pro6F2Payment.feb21 + pro6F3Payment.feb21
]
export const pro6WithFeb21Count = [
    pro6F1Collectable.feb21,
    pro6F2Collectable.feb21,
    pro6F3Collectable.feb21,
    pro6F1Collectable.feb21 + pro6F2Collectable.feb21 + pro6F3Collectable.feb21
]
export const pro6WithFeb21NonCount = [
    pro6F1NonCollectable.feb21,
    pro6F2NonCollectable.feb21,
    pro6F3NonCollectable.feb21,
    pro6F1NonCollectable.feb21 + pro6F2NonCollectable.feb21 + pro6F3NonCollectable.feb21
]
export const pro6WithFeb21Claim = [
    pro6F1ClaimCount.feb21,
    pro6F2ClaimCount.feb21,
    pro6F3ClaimCount.feb21,
    pro6F1ClaimCount.feb21 + pro6F2ClaimCount.feb21 + pro6F3ClaimCount.feb21
]
export const pro6WithFeb21PerVisit = [
    pro6F1PerVisit.feb21,
    pro6F2PerVisit.feb21,
    pro6F3PerVisit.feb21,
    provider6PerVisist[1]
]
// mar 21
export const pro6WithMar21Charges = [
    pro6F1Charge.mar21,
    pro6F2Charge.mar21,
    pro6F3Charge.mar21,
    pro6F1Charge.mar21 + pro6F2Charge.mar21 + pro6F3Charge.mar21
]
export const pro6WithMar21Pay = [
    pro6F1Payment.mar21,
    pro6F2Payment.mar21,
    pro6F3Payment.mar21,
    pro6F1Payment.mar21 + pro6F2Payment.mar21 + pro6F3Payment.mar21
]
export const pro6WithMar21Count = [
    pro6F1Collectable.mar21,
    pro6F2Collectable.mar21,
    pro6F3Collectable.mar21,
    pro6F1Collectable.mar21 + pro6F2Collectable.mar21 + pro6F3Collectable.mar21
]
export const pro6WithMar21NonCount = [
    pro6F1NonCollectable.mar21,
    pro6F2NonCollectable.mar21,
    pro6F3NonCollectable.mar21,
    pro6F1NonCollectable.mar21 + pro6F2NonCollectable.mar21 + pro6F3NonCollectable.mar21
]
export const pro6WithMar21Claim = [
    pro6F1ClaimCount.mar21,
    pro6F2ClaimCount.mar21,
    pro6F3ClaimCount.mar21,
    pro6F1ClaimCount.mar21 + pro6F2ClaimCount.mar21 + pro6F3ClaimCount.mar21
]
export const pro6WithMar21PerVisit = [
    pro6F1PerVisit.mar21,
    pro6F2PerVisit.mar21,
    pro6F3PerVisit.mar21,
    provider6PerVisist[2]
]
// april 21
export const pro6WithApr21Charges = [
    pro6F1Charge.apr21,
    pro6F2Charge.apr21,
    pro6F3Charge.apr21,
    pro6F1Charge.apr21 + pro6F2Charge.apr21 + pro6F3Charge.apr21
]
export const pro6WithApr21Pay = [
    pro6F1Payment.apr21,
    pro6F2Payment.apr21,
    pro6F3Payment.apr21,
    pro6F1Payment.apr21 + pro6F2Payment.apr21 + pro6F3Payment.apr21
]
export const pro6WithApr21Count = [
    pro6F1Collectable.apr21,
    pro6F2Collectable.apr21,
    pro6F3Collectable.apr21,
    pro6F1Collectable.apr21 + pro6F2Collectable.apr21 + pro6F3Collectable.apr21
]
export const pro6WithApr21NonCount = [
    pro6F1NonCollectable.apr21,
    pro6F2NonCollectable.apr21,
    pro6F3NonCollectable.apr21,
    pro6F1NonCollectable.apr21 + pro6F2NonCollectable.apr21 + pro6F3NonCollectable.apr21
]
export const pro6WithApr21Claim = [
    pro6F1ClaimCount.apr21,
    pro6F2ClaimCount.apr21,
    pro6F3ClaimCount.apr21,
    pro6F1ClaimCount.apr21 + pro6F2ClaimCount.apr21 + pro6F3ClaimCount.apr21
]
export const pro6WithApr21PerVisit = [
    pro6F1PerVisit.apr21,
    pro6F2PerVisit.apr21,
    pro6F3PerVisit.apr21,
    provider6PerVisist[3]
]
// may 21
export const pro6WithMay21Charges = [
    pro6F1Charge.may21,
    pro6F2Charge.may21,
    pro6F3Charge.may21,
    pro6F1Charge.may21 + pro6F2Charge.may21 + pro6F3Charge.may21
]
export const pro6WithMay21Pay = [
    pro6F1Payment.may21,
    pro6F2Payment.may21,
    pro6F3Payment.may21,
    pro6F1Payment.may21 + pro6F2Payment.may21 + pro6F3Payment.may21
]
export const pro6WithMay21Count = [
    pro6F1Collectable.may21,
    pro6F2Collectable.may21,
    pro6F3Collectable.may21,
    pro6F1Collectable.may21 + pro6F2Collectable.may21 + pro6F3Collectable.may21
]
export const pro6WithMay21NonCount = [
    pro6F1NonCollectable.may21,
    pro6F2NonCollectable.may21,
    pro6F3NonCollectable.may21,
    pro6F1NonCollectable.may21 + pro6F2NonCollectable.may21 + pro6F3NonCollectable.may21
]
export const pro6WithMay21Claim = [
    pro6F1ClaimCount.may21,
    pro6F2ClaimCount.may21,
    pro6F3ClaimCount.may21,
    pro6F1ClaimCount.may21 + pro6F2ClaimCount.may21 + pro6F3ClaimCount.may21
]
export const pro6WithMay21PerVisit = [
    pro6F1PerVisit.may21,
    pro6F2PerVisit.may21,
    pro6F3PerVisit.may21,
    provider6PerVisist[4]
]
// jun 21
export const pro6WithJun21Charges = [
    pro6F1Charge.jun21,
    pro6F2Charge.jun21,
    pro6F3Charge.jun21,
    pro6F1Charge.jun21 + pro6F2Charge.jun21 + pro6F3Charge.jun21
]
export const pro6WithJun21Pay = [
    pro6F1Payment.jun21,
    pro6F2Payment.jun21,
    pro6F3Payment.jun21,
    pro6F1Payment.jun21 + pro6F2Payment.jun21 + pro6F3Payment.jun21
]
export const pro6WithJun21Count = [
    pro6F1Collectable.jun21,
    pro6F2Collectable.jun21,
    pro6F3Collectable.jun21,
    pro6F1Collectable.jun21 + pro6F2Collectable.jun21 + pro6F3Collectable.jun21
]
export const pro6WithJun21NonCount = [
    pro6F1NonCollectable.jun21,
    pro6F2NonCollectable.jun21,
    pro6F3NonCollectable.jun21,
    pro6F1NonCollectable.jun21 + pro6F2NonCollectable.jun21 + pro6F3NonCollectable.jun21
]
export const pro6WithJun21Claim = [
    pro6F1ClaimCount.jun21,
    pro6F2ClaimCount.jun21,
    pro6F3ClaimCount.jun21,
    pro6F1ClaimCount.jun21 + pro6F2ClaimCount.jun21 + pro6F3ClaimCount.jun21
]
export const pro6WithJun21PerVisit = [
    pro6F1PerVisit.jun21,
    pro6F2PerVisit.jun21,
    pro6F3PerVisit.jun21,
    provider6PerVisist[5]
]
// jul 21
export const pro6WithJul21Charges = [
    pro6F1Charge.jul21,
    pro6F2Charge.jul21,
    pro6F3Charge.jul21,
    pro6F1Charge.jul21 + pro6F2Charge.jul21 + pro6F3Charge.jul21,

]
export const pro6WithJul21Pay = [
    pro6F1Payment.jul21,
    pro6F2Payment.jul21,
    pro6F3Payment.jul21,
    pro6F1Payment.jul21 + pro6F2Payment.jul21 + pro6F3Payment.jul21
]
export const pro6WithJul21Count = [
    pro6F1Collectable.jul21,
    pro6F2Collectable.jul21,
    pro6F3Collectable.jul21,
    pro6F1Collectable.jul21 + pro6F2Collectable.jul21 + pro6F3Collectable.jul21
]
export const pro6WithJul21NonCount = [
    pro6F1NonCollectable.jul21,
    pro6F2NonCollectable.jul21,
    pro6F3NonCollectable.jul21,
    pro6F1NonCollectable.jul21 + pro6F2NonCollectable.jul21 + pro6F3NonCollectable.jul21
]
export const pro6WithJul21Claim = [
    pro6F1ClaimCount.jul21,
    pro6F2ClaimCount.jul21,
    pro6F3ClaimCount.jul21,
    pro6F1ClaimCount.jul21 + pro6F2ClaimCount.jul21 + pro6F3ClaimCount.jul21
]
export const pro6WithJul21PerVisit = [
    pro6F1PerVisit.jul21,
    pro6F2PerVisit.jul21,
    pro6F3PerVisit.jul21,
    provider6PerVisist[6]
]
// aug 21
export const pro6WithAug21Charges = [
    pro6F1Charge.aug21,
    pro6F2Charge.aug21,
    pro6F3Charge.aug21,
    pro6F1Charge.aug21 + pro6F2Charge.aug21 + pro6F3Charge.aug21
]
export const pro6WithAug21Pay = [
    pro6F1Payment.aug21,
    pro6F2Payment.aug21,
    pro6F3Payment.aug21,
    pro6F1Payment.aug21 + pro6F2Payment.aug21 + pro6F3Payment.aug21
]
export const pro6WithAug21Count = [
    pro6F1Collectable.aug21,
    pro6F2Collectable.aug21,
    pro6F3Collectable.aug21,
    pro6F1Collectable.aug21 + pro6F2Collectable.aug21 + pro6F3Collectable.aug21
]
export const pro6WithAug21NonCount = [
    pro6F1NonCollectable.aug21,
    pro6F2NonCollectable.aug21,
    pro6F3NonCollectable.aug21,
    pro6F1NonCollectable.aug21 + pro6F2NonCollectable.aug21 + pro6F3NonCollectable.aug21
]
export const pro6WithAug21Claim = [
    pro6F1ClaimCount.aug21,
    pro6F2ClaimCount.aug21,
    pro6F3ClaimCount.aug21,
    pro6F1ClaimCount.aug21 + pro6F2ClaimCount.aug21 + pro6F3ClaimCount.aug21
]
export const pro6WithAug21PerVisit = [
    pro6F1PerVisit.aug21,
    pro6F2PerVisit.aug21,
    pro6F3PerVisit.aug21,
    provider6PerVisist[7]
]
// sep 21
export const pro6WithSep21Charges = [
    pro6F1Charge.sep21,
    pro6F2Charge.sep21,
    pro6F3Charge.sep21,
    pro6F1Charge.sep21 + pro6F2Charge.sep21 + pro6F3Charge.sep21
]
export const pro6WithSep21Pay = [
    pro6F1Payment.sep21,
    pro6F2Payment.sep21,
    pro6F3Payment.sep21,
    pro6F1Payment.sep21 + pro6F2Payment.sep21 + pro6F3Payment.sep21
]
export const pro6WithSep21Count = [
    pro6F1Collectable.sep21,
    pro6F2Collectable.sep21,
    pro6F3Collectable.sep21,
    pro6F1Collectable.sep21 + pro6F2Collectable.sep21 + pro6F3Collectable.sep21
]
export const pro6WithSep21NonCount = [
    pro6F1NonCollectable.sep21,
    pro6F2NonCollectable.sep21,
    pro6F3NonCollectable.sep21,
    pro6F1NonCollectable.sep21 + pro6F2NonCollectable.sep21 + pro6F3NonCollectable.sep21
]
export const pro6WithSep21Claim = [
    pro6F1ClaimCount.sep21,
    pro6F2ClaimCount.sep21,
    pro6F3ClaimCount.sep21,
    pro6F1ClaimCount.sep21 + pro6F2ClaimCount.sep21 + pro6F3ClaimCount.sep21
]
export const pro6WithSep21PerVisit = [
    pro6F1PerVisit.sep21,
    pro6F2PerVisit.sep21,
    pro6F3PerVisit.sep21,
    provider6PerVisist[8]
]
// oct 21
export const pro6WithOct21Charges = [
    pro6F1Charge.oct21,
    pro6F2Charge.oct21,
    pro6F3Charge.oct21,
    pro6F1Charge.oct21 + pro6F2Charge.oct21 + pro6F3Charge.oct21
]
export const pro6WithOct21Pay = [
    pro6F1Payment.oct21,
    pro6F2Payment.oct21,
    pro6F3Payment.oct21,
    pro6F1Payment.oct21 + pro6F2Payment.oct21 + pro6F3Payment.oct21
]
export const pro6WithOct21Count = [
    pro6F1Collectable.oct21,
    pro6F2Collectable.oct21,
    pro6F3Collectable.oct21,
    pro6F1Collectable.oct21 + pro6F2Collectable.oct21 + pro6F3Collectable.oct21
]
export const pro6WithOct21NonCount = [
    pro6F1NonCollectable.oct21,
    pro6F2NonCollectable.oct21,
    pro6F3NonCollectable.oct21,
    pro6F1NonCollectable.oct21 + pro6F2NonCollectable.oct21 + pro6F3NonCollectable.oct21
]
export const pro6WithOct21Claim = [
    pro6F1ClaimCount.oct21,
    pro6F2ClaimCount.oct21,
    pro6F3ClaimCount.oct21,
    pro6F1ClaimCount.oct21 + pro6F2ClaimCount.oct21 + pro6F3ClaimCount.oct21
]
export const pro6WithOct21PerVisit = [
    pro6F1PerVisit.oct21,
    pro6F2PerVisit.oct21,
    pro6F3PerVisit.oct21,
    provider6PerVisist[9]
]
// nov 21
export const pro6WithNov21Charges = [
    pro6F1Charge.nov21,
    pro6F2Charge.nov21,
    pro6F3Charge.nov21,
    pro6F1Charge.nov21 + pro6F2Charge.nov21 + pro6F3Charge.nov21
]
export const pro6WithNov21Pay = [
    pro6F1Payment.nov21,
    pro6F2Payment.nov21,
    pro6F3Payment.nov21,
    pro6F1Payment.nov21 + pro6F2Payment.nov21 + pro6F3Payment.nov21
]
export const pro6WithNov21Count = [
    pro6F1Collectable.nov21,
    pro6F2Collectable.nov21,
    pro6F3Collectable.nov21,
    pro6F1Collectable.nov21 + pro6F2Collectable.nov21 + pro6F3Collectable.nov21
]
export const pro6WithNov21NonCount = [
    pro6F1NonCollectable.nov21,
    pro6F2NonCollectable.nov21,
    pro6F3NonCollectable.nov21,
    pro6F1NonCollectable.nov21 + pro6F2NonCollectable.nov21 + pro6F3NonCollectable.nov21
]
export const pro6WithNov21Claim = [
    pro6F1ClaimCount.nov21,
    pro6F2ClaimCount.nov21,
    pro6F3ClaimCount.nov21,
    pro6F1ClaimCount.nov21 + pro6F2ClaimCount.nov21 + pro6F3ClaimCount.nov21
]
export const pro6WithNov21PerVisit = [
    pro6F1PerVisit.nov21,
    pro6F2PerVisit.nov21,
    pro6F3PerVisit.nov21,
    provider6PerVisist[10]
]
// dec 21
export const pro6WithDec21Charges = [
    pro6F1Charge.dec21,
    pro6F2Charge.dec21,
    pro6F3Charge.dec21,
    pro6F1Charge.dec21 + pro6F2Charge.dec21 + pro6F3Charge.dec21
]
export const pro6WithDec21Pay = [
    pro6F1Payment.dec21,
    pro6F2Payment.dec21,
    pro6F3Payment.dec21,
    pro6F1Payment.dec21 + pro6F2Payment.dec21 + pro6F3Payment.dec21
]
export const pro6WithDec21Count = [
    pro6F1Collectable.dec21,
    pro6F2Collectable.dec21,
    pro6F3Collectable.dec21,
    pro6F1Collectable.dec21 + pro6F2Collectable.dec21 + pro6F3Collectable.dec21
]
export const pro6WithDec21NonCount = [
    pro6F1NonCollectable.dec21,
    pro6F2NonCollectable.dec21,
    pro6F3NonCollectable.dec21,
    pro6F1NonCollectable.dec21 + pro6F2NonCollectable.dec21 + pro6F3NonCollectable.dec21
] 
export const pro6WithDec21Claim = [
    pro6F1ClaimCount.dec21,
    pro6F2ClaimCount.dec21,
    pro6F3ClaimCount.dec21,
    pro6F1ClaimCount.dec21 + pro6F2ClaimCount.dec21 + pro6F3ClaimCount.dec21
]
export const pro6WithDec21PerVisit = [
    pro6F1PerVisit.dec21,
    pro6F2PerVisit.dec21,
    pro6F3PerVisit.dec21,
    provider6PerVisist[11]
]

// provider-1 
// jan 22
export const pro6WithJan22Charges = [
    pro6F1Charge.jan22,
    pro6F2Charge.jan22,
    pro6F3Charge.jan22,
    pro6F1Charge.jan22 + pro6F2Charge.jan22 + pro6F3Charge.jan22
]
export const pro6WithJan22Pay = [
    pro6F1Payment.jan22,
    pro6F2Payment.jan22,
    pro6F3Payment.jan22,
    pro6F1Payment.jan22 + pro6F2Payment.jan22 + pro6F3Payment.jan22
]
export const pro6WithJan22Count = [
    pro6F1Collectable.jan22,
    pro6F2Collectable.jan22,
    pro6F3Collectable.jan22,
    pro6F1Collectable.jan22 + pro6F2Collectable.jan22 + pro6F3Collectable.jan22
]
export const pro6WithJan22NonCount = [
    pro6F1NonCollectable.jan22,
    pro6F2NonCollectable.jan22,
    pro6F3NonCollectable.jan22,
    pro6F1NonCollectable.jan22 + pro6F2NonCollectable.jan22 + pro6F3NonCollectable.jan22
]
export const pro6WithJan22Claim = [
    pro6F1ClaimCount.jan22,
    pro6F2ClaimCount.jan22,
    pro6F3ClaimCount.jan22,
    pro6F1ClaimCount.jan22 + pro6F2ClaimCount.jan22 + pro6F3ClaimCount.jan22
]
export const pro6WithJan22PerVisit = [
    pro6F1PerVisit.jan22,
    pro6F2PerVisit.jan22,
    pro6F3PerVisit.jan22,
    provider6PerVisist[12]
]
// feb 22
export const pro6WithFeb22Charges = [
    pro6F1Charge.feb22,
    pro6F2Charge.feb22,
    pro6F3Charge.feb22,
    pro6F1Charge.feb22 + pro6F2Charge.feb22 + pro6F3Charge.feb22
]
export const pro6WithFeb22Pay = [
    pro6F1Payment.feb22,
    pro6F2Payment.feb22,
    pro6F3Payment.feb22,
    pro6F1Payment.feb22 + pro6F2Payment.feb22 + pro6F3Payment.feb22
]
export const pro6WithFeb22Count = [
    pro6F1Collectable.feb22,
    pro6F2Collectable.feb22,
    pro6F3Collectable.feb22,
    pro6F1Collectable.feb22 + pro6F2Collectable.feb22 + pro6F3Collectable.feb22
]
export const pro6WithFeb22NonCount = [
    pro6F1NonCollectable.feb22,
    pro6F2NonCollectable.feb22,
    pro6F3NonCollectable.feb22,
    pro6F1NonCollectable.feb22 + pro6F2NonCollectable.feb22 + pro6F3NonCollectable.feb22
]
export const pro6WithFeb22Claim = [
    pro6F1ClaimCount.feb22,
    pro6F2ClaimCount.feb22,
    pro6F3ClaimCount.feb22,
    pro6F1ClaimCount.feb22 + pro6F2ClaimCount.feb22 + pro6F3ClaimCount.feb22
]
export const pro6WithFeb22PerVisit = [
    pro6F1PerVisit.feb22,
    pro6F2PerVisit.feb22,
    pro6F3PerVisit.feb22,
    provider6PerVisist[13]
]
// mar 22
export const pro6WithMar22Charges = [
    pro6F1Charge.mar22,
    pro6F2Charge.mar22,
    pro6F3Charge.mar22,
    pro6F1Charge.mar22 + pro6F2Charge.mar22 + pro6F3Charge.mar22
]
export const pro6WithMar22Pay = [
    pro6F1Payment.mar22,
    pro6F2Payment.mar22,
    pro6F3Payment.mar22,
    pro6F1Payment.mar22 + pro6F2Payment.mar22 + pro6F3Payment.mar22
]
export const pro6WithMar22Count = [
    pro6F1Collectable.mar22,
    pro6F2Collectable.mar22,
    pro6F3Collectable.mar22,
    pro6F1Collectable.mar22 + pro6F2Collectable.mar22 + pro6F3Collectable.mar22
]
export const pro6WithMar22NonCount = [
    pro6F1NonCollectable.mar22,
    pro6F2NonCollectable.mar22,
    pro6F3NonCollectable.mar22,
    pro6F1NonCollectable.mar22 + pro6F2NonCollectable.mar22 + pro6F3NonCollectable.mar22
]
export const pro6WithMar22Claim = [
    pro6F1ClaimCount.mar22,
    pro6F2ClaimCount.mar22,
    pro6F3ClaimCount.mar22,
    pro6F1ClaimCount.mar22 + pro6F2ClaimCount.mar22 + pro6F3ClaimCount.mar22
]
export const pro6WithMar22PerVisit = [
    pro6F1PerVisit.mar22,
    pro6F2PerVisit.mar22,
    pro6F3PerVisit.mar22,
    provider6PerVisist[14]
]
// april 22
export const pro6WithApr22Charges = [
    pro6F1Charge.apr22,
    pro6F2Charge.apr22,
    pro6F3Charge.apr22,
    pro6F1Charge.apr22 + pro6F2Charge.apr22 + pro6F3Charge.apr22
]
export const pro6WithApr22Pay = [
    pro6F1Payment.apr22,
    pro6F2Payment.apr22,
    pro6F3Payment.apr22,
    pro6F1Payment.apr22 + pro6F2Payment.apr22 + pro6F3Payment.apr22
]
export const pro6WithApr22Count = [
    pro6F1Collectable.apr22,
    pro6F2Collectable.apr22,
    pro6F3Collectable.apr22,
    pro6F1Collectable.apr22 + pro6F2Collectable.apr22 + pro6F3Collectable.apr22
]
export const pro6WithApr22NonCount = [
    pro6F1NonCollectable.apr22,
    pro6F2NonCollectable.apr22,
    pro6F3NonCollectable.apr22,
    pro6F1NonCollectable.apr22 + pro6F2NonCollectable.apr22 + pro6F3NonCollectable.apr22
]
export const pro6WithApr22Claim = [
    pro6F1ClaimCount.apr22,
    pro6F2ClaimCount.apr22,
    pro6F3ClaimCount.apr22,
    pro6F1ClaimCount.apr22 + pro6F2ClaimCount.apr22 + pro6F3ClaimCount.apr22
]
export const pro6WithApr22PerVisit = [
    pro6F1PerVisit.apr22,
    pro6F2PerVisit.apr22,
    pro6F3PerVisit.apr22,
    provider6PerVisist[15]
]
// may 22
export const pro6WithMay22Charges = [
    pro6F1Charge.may22,
    pro6F2Charge.may22,
    pro6F3Charge.may22,
    pro6F1Charge.may22 + pro6F2Charge.may22 + pro6F3Charge.may22
]
export const pro6WithMay22Pay = [
    pro6F1Payment.may22,
    pro6F2Payment.may22,
    pro6F3Payment.may22,
    pro6F1Payment.may22 + pro6F2Payment.may22 + pro6F3Payment.may22
]
export const pro6WithMay22Count = [
    pro6F1Collectable.may22,
    pro6F2Collectable.may22,
    pro6F3Collectable.may22,
    pro6F1Collectable.may22 + pro6F2Collectable.may22 + pro6F3Collectable.may22
]
export const pro6WithMay22NonCount = [
    pro6F1NonCollectable.may22,
    pro6F2NonCollectable.may22,
    pro6F3NonCollectable.may22,
    pro6F1NonCollectable.may22 + pro6F2NonCollectable.may22 + pro6F3NonCollectable.may22
]
export const pro6WithMay22Claim = [
    pro6F1ClaimCount.may22,
    pro6F2ClaimCount.may22,
    pro6F3ClaimCount.may22,
    pro6F1ClaimCount.may22 + pro6F2ClaimCount.may22 + pro6F3ClaimCount.may22
]
export const pro6WithMay22PerVisit = [
    pro6F1PerVisit.may22,
    pro6F2PerVisit.may22,
    pro6F3PerVisit.may22,
    provider6PerVisist[16]
]
// jun 22
export const pro6WithJun22Charges = [
    pro6F1Charge.jun22,
    pro6F2Charge.jun22,
    pro6F3Charge.jun22,
    pro6F1Charge.jun22 + pro6F2Charge.jun22 + pro6F3Charge.jun22
]
export const pro6WithJun22Pay = [
    pro6F1Payment.jun22,
    pro6F2Payment.jun22,
    pro6F3Payment.jun22,
    pro6F1Payment.jun22 + pro6F2Payment.jun22 + pro6F3Payment.jun22
]
export const pro6WithJun22Count = [
    pro6F1Collectable.jun22,
    pro6F2Collectable.jun22,
    pro6F3Collectable.jun22,
    pro6F1Collectable.jun22 + pro6F2Collectable.jun22 + pro6F3Collectable.jun22
]
export const pro6WithJun22NonCount = [
    pro6F1NonCollectable.jun22,
    pro6F2NonCollectable.jun22,
    pro6F3NonCollectable.jun22,
    pro6F1NonCollectable.jun22 + pro6F2NonCollectable.jun22 + pro6F3NonCollectable.jun22
]
export const pro6WithJun22Claim = [
    pro6F1ClaimCount.jun22,
    pro6F2ClaimCount.jun22,
    pro6F3ClaimCount.jun22,
    pro6F1ClaimCount.jun22 + pro6F2ClaimCount.jun22 + pro6F3ClaimCount.jun22
]
export const pro6WithJun22PerVisit = [
    pro6F1PerVisit.jun22,
    pro6F2PerVisit.jun22,
    pro6F3PerVisit.jun22,
    provider6PerVisist[17]
]
// jul 22
export const pro6WithJul22Charges = [
    pro6F1Charge.jul22,
    pro6F2Charge.jul22,
    pro6F3Charge.jul22,
    pro6F1Charge.jul22 + pro6F2Charge.jul22 + pro6F3Charge.jul22
]
export const pro6WithJul22Pay = [
    pro6F1Payment.jul22,
    pro6F2Payment.jul22,
    pro6F3Payment.jul22,
    pro6F1Payment.jul22 + pro6F2Payment.jul22 + pro6F3Payment.jul22
]
export const pro6WithJul22Count = [
    pro6F1Collectable.jul22,
    pro6F2Collectable.jul22,
    pro6F3Collectable.jul22,
    pro6F1Collectable.jul22 + pro6F2Collectable.jul22 + pro6F3Collectable.jul22
]
export const pro6WithJul22NonCount = [
    pro6F1NonCollectable.jul22,
    pro6F2NonCollectable.jul22,
    pro6F3NonCollectable.jul22,
    pro6F1NonCollectable.jul22 + pro6F2NonCollectable.jul22 + pro6F3NonCollectable.jul22
]
export const pro6WithJul22Claim = [
    pro6F1ClaimCount.jul22,
    pro6F2ClaimCount.jul22,
    pro6F3ClaimCount.jul22,
    pro6F1ClaimCount.jul22 + pro6F2ClaimCount.jul22 + pro6F3ClaimCount.jul22
]
export const pro6WithJul22PerVisit = [
    pro6F1PerVisit.jul22,
    pro6F2PerVisit.jul22,
    pro6F3PerVisit.jul22,
    provider6PerVisist[18]
]
// aug 22
export const pro6WithAug22Charges = [
    pro6F1Charge.aug22,
    pro6F2Charge.aug22,
    pro6F3Charge.aug22,
    pro6F1Charge.aug22 + pro6F2Charge.aug22 + pro6F3Charge.aug22
]
export const pro6WithAug22Pay = [
    pro6F1Payment.aug22,
    pro6F2Payment.aug22,
    pro6F3Payment.aug22,
    pro6F1Payment.aug22 + pro6F2Payment.aug22 + pro6F3Payment.aug22
]
export const pro6WithAug22Count = [
    pro6F1Collectable.aug22,
    pro6F2Collectable.aug22,
    pro6F3Collectable.aug22,
    pro6F1Collectable.aug22 + pro6F2Collectable.aug22 + pro6F3Collectable.aug22
]
export const pro6WithAug22NonCount = [
    pro6F1NonCollectable.aug22,
    pro6F2NonCollectable.aug22,
    pro6F3NonCollectable.aug22,
    pro6F1NonCollectable.aug22 + pro6F2NonCollectable.aug22 + pro6F3NonCollectable.aug22
]
export const pro6WithAug22Claim = [
    pro6F1ClaimCount.aug22,
    pro6F2ClaimCount.aug22,
    pro6F3ClaimCount.aug22,
    pro6F1ClaimCount.aug22 + pro6F2ClaimCount.aug22 + pro6F3ClaimCount.aug22
]
export const pro6WithAug22PerVisit = [
    pro6F1PerVisit.aug22,
    pro6F2PerVisit.aug22,
    pro6F3PerVisit.aug22,
    provider6PerVisist[19]
]
// sep 22
export const pro6WithSep22Charges = [
    pro6F1Charge.sep22,
    pro6F2Charge.sep22,
    pro6F3Charge.sep22,
    pro6F1Charge.sep22 + pro6F2Charge.sep22 + pro6F3Charge.sep22
]
export const pro6WithSep22Pay = [
    pro6F1Payment.sep22,
    pro6F2Payment.sep22,
    pro6F3Payment.sep22,
    pro6F1Payment.sep22 + pro6F2Payment.sep22 + pro6F3Payment.sep22
]
export const pro6WithSep22Count = [
    pro6F1Collectable.sep22,
    pro6F2Collectable.sep22,
    pro6F3Collectable.sep22,
    pro6F1Collectable.sep22 + pro6F2Collectable.sep22 + pro6F3Collectable.sep22
]
export const pro6WithSep22NonCount = [
    pro6F1NonCollectable.sep22,
    pro6F2NonCollectable.sep22,
    pro6F3NonCollectable.sep22,
    pro6F1NonCollectable.sep22 + pro6F2NonCollectable.sep22 + pro6F3NonCollectable.sep22
]
export const pro6WithSep22Claim = [
    pro6F1ClaimCount.sep22,
    pro6F2ClaimCount.sep22,
    pro6F3ClaimCount.sep22,
    pro6F1ClaimCount.sep22 + pro6F2ClaimCount.sep22 + pro6F3ClaimCount.sep22
]
export const pro6WithSep22PerVisit = [
    pro6F1PerVisit.sep22,
    pro6F2PerVisit.sep22,
    pro6F3PerVisit.sep22,
    provider6PerVisist[20]
]
// oct 22
export const pro6WithOct22Charges = [
    pro6F1Charge.oct22,
    pro6F2Charge.oct22,
    pro6F3Charge.oct22,
    pro6F1Charge.oct22 + pro6F2Charge.oct22 + pro6F3Charge.oct22
]
export const pro6WithOct22Pay = [
    pro6F1Payment.oct22,
    pro6F2Payment.oct22,
    pro6F3Payment.oct22,
    pro6F1Payment.oct22 + pro6F2Payment.oct22 + pro6F3Payment.oct22
]
export const pro6WithOct22Count = [
    pro6F1Collectable.oct22,
    pro6F2Collectable.oct22,
    pro6F3Collectable.oct22,
    pro6F1Collectable.oct22 + pro6F2Collectable.oct22 + pro6F3Collectable.oct22
]
export const pro6WithOct22NonCount = [
    pro6F1NonCollectable.oct22,
    pro6F2NonCollectable.oct22,
    pro6F3NonCollectable.oct22,
    pro6F1NonCollectable.oct22 + pro6F2NonCollectable.oct22 + pro6F3NonCollectable.oct22
]
export const pro6WithOct22Claim = [
    pro6F1ClaimCount.oct22,
    pro6F2ClaimCount.oct22,
    pro6F3ClaimCount.oct22,
    pro6F1ClaimCount.oct22 + pro6F2ClaimCount.oct22 + pro6F3ClaimCount.oct22
]
export const pro6WithOct22PerVisit = [
    pro6F1PerVisit.oct22,
    pro6F2PerVisit.oct22,
    pro6F3PerVisit.oct22,
    provider6PerVisist[21]
]
// nov 22
export const pro6WithNov22Charges = [
    pro6F1Charge.nov22,
    pro6F2Charge.nov22,
    pro6F3Charge.nov22,
    pro6F1Charge.nov22 + pro6F2Charge.nov22 + pro6F3Charge.nov22
]
export const pro6WithNov22Pay = [
    pro6F1Payment.nov22,
    pro6F2Payment.nov22,
    pro6F3Payment.nov22,
    pro6F1Payment.nov22 + pro6F2Payment.nov22 + pro6F3Payment.nov22
]
export const pro6WithNov22Count = [
    pro6F1Collectable.nov22,
    pro6F2Collectable.nov22,
    pro6F3Collectable.nov22,
    pro6F1Collectable.nov22 + pro6F2Collectable.nov22 + pro6F3Collectable.nov22
]
export const pro6WithNov22NonCount = [
    pro6F1NonCollectable.nov22,
    pro6F2NonCollectable.nov22,
    pro6F3NonCollectable.nov22,
    pro6F1NonCollectable.nov22 + pro6F2NonCollectable.nov22 + pro6F3NonCollectable.nov22
]
export const pro6WithNov22Claim = [
    pro6F1ClaimCount.nov22,
    pro6F2ClaimCount.nov22,
    pro6F3ClaimCount.nov22,
    pro6F1ClaimCount.nov22 + pro6F2ClaimCount.nov22 + pro6F3ClaimCount.nov22
]
export const pro6WithNov22PerVisit = [
    pro6F1PerVisit.nov22,
    pro6F2PerVisit.nov22,
    pro6F3PerVisit.nov22,
    provider6PerVisist[22]
]
// dec 22
export const pro6WithDec22Charges = [
    pro6F1Charge.dec22,
    pro6F2Charge.dec22,
    pro6F3Charge.dec22,
    pro6F1Charge.dec22 + pro6F2Charge.dec22 + pro6F3Charge.dec22
]
export const pro6WithDec22Pay = [
    pro6F1Payment.dec22,
    pro6F2Payment.dec22,
    pro6F3Payment.dec22,
    pro6F1Payment.dec22 + pro6F2Payment.dec22 + pro6F3Payment.dec22
]
export const pro6WithDec22Count = [
    pro6F1Collectable.dec22,
    pro6F2Collectable.dec22,
    pro6F3Collectable.dec22,
    pro6F1Collectable.dec22 + pro6F2Collectable.dec22 + pro6F3Collectable.dec22
]
export const pro6WithDec22NonCount = [
    pro6F1NonCollectable.dec22,
    pro6F2NonCollectable.dec22,
    pro6F3NonCollectable.dec22,
    pro6F1NonCollectable.dec22 + pro6F2NonCollectable.dec22 + pro6F3NonCollectable.dec22
]
export const pro6WithDec22Claim = [
    pro6F1ClaimCount.dec22,
    pro6F2ClaimCount.dec22,
    pro6F3ClaimCount.dec22,
    pro6F1ClaimCount.dec22 + pro6F2ClaimCount.dec22 + pro6F3ClaimCount.dec22
]
export const pro6WithDec22PerVisit = [
    pro6F1PerVisit.dec22,
    pro6F2PerVisit.dec22,
    pro6F3PerVisit.dec22,
    provider6PerVisist[23]
]

// provider-1 
// jan 23
export const pro6WithJan23Charges = [
    pro6F1Charge.jan23,
    pro6F2Charge.jan23,
    pro6F3Charge.jan23,
    pro6F1Charge.jan23 + pro6F2Charge.jan23 + pro6F3Charge.jan23
]
export const pro6WithJan23Pay = [
    pro6F1Payment.jan23,
    pro6F2Payment.jan23,
    pro6F3Payment.jan23,
    pro6F1Payment.jan23 + pro6F2Payment.jan23 + pro6F3Payment.jan23
]
export const pro6WithJan23Count = [
    pro6F1Collectable.jan23,
    pro6F2Collectable.jan23,
    pro6F3Collectable.jan23,
    pro6F1Collectable.jan23 + pro6F2Collectable.jan23 + pro6F3Collectable.jan23
]
export const pro6WithJan23NonCount = [
    pro6F1NonCollectable.jan23,
    pro6F2NonCollectable.jan23,
    pro6F3NonCollectable.jan23,
    pro6F1NonCollectable.jan23 + pro6F2NonCollectable.jan23 + pro6F3NonCollectable.jan23
]
export const pro6WithJan23Claim = [
    pro6F1ClaimCount.jan23,
    pro6F2ClaimCount.jan23,
    pro6F3ClaimCount.jan23,
    pro6F1ClaimCount.jan23 + pro6F2ClaimCount.jan23 + pro6F3ClaimCount.jan23
]
export const pro6WithJan23PerVisit = [
    pro6F1PerVisit.jan23,
    pro6F2PerVisit.jan23,
    pro6F3PerVisit.jan23,
    provider6PerVisist[24]
]
// feb 23
export const pro6WithFeb23Charges = [
    pro6F1Charge.feb23,
    pro6F2Charge.feb23,
    pro6F3Charge.feb23,
    pro6F1Charge.feb23 + pro6F2Charge.feb23 + pro6F3Charge.feb23
]
export const pro6WithFeb23Pay = [
    pro6F1Payment.feb23,
    pro6F2Payment.feb23,
    pro6F3Payment.feb23,
    pro6F1Payment.feb23 + pro6F2Payment.feb23 + pro6F3Payment.feb23
]
export const pro6WithFeb23Count = [
    pro6F1Collectable.feb23,
    pro6F2Collectable.feb23,
    pro6F3Collectable.feb23,
    pro6F1Collectable.feb23 + pro6F2Collectable.feb23 + pro6F3Collectable.feb23
]
export const pro6WithFeb23NonCount = [
    pro6F1NonCollectable.feb23,
    pro6F2NonCollectable.feb23,
    pro6F3NonCollectable.feb23,
    pro6F1NonCollectable.feb23 + pro6F2NonCollectable.feb23 + pro6F3NonCollectable.feb23
]
export const pro6WithFeb23Claim = [
    pro6F1ClaimCount.feb23,
    pro6F2ClaimCount.feb23,
    pro6F3ClaimCount.feb23,
    pro6F1ClaimCount.feb23 + pro6F2ClaimCount.feb23 + pro6F3ClaimCount.feb23
]
export const pro6WithFeb23PerVisit = [
    pro6F1PerVisit.feb23,
    pro6F2PerVisit.feb23,
    pro6F3PerVisit.feb23,
    provider6PerVisist[25]
]
// mar 23
export const pro6WithMar23Charges = [
    pro6F1Charge.mar23,
    pro6F2Charge.mar23,
    pro6F3Charge.mar23,
    pro6F1Charge.mar23 + pro6F2Charge.mar23 + pro6F3Charge.mar23
]
export const pro6WithMar23Pay = [
    pro6F1Payment.mar23,
    pro6F2Payment.mar23,
    pro6F3Payment.mar23,
    pro6F1Payment.mar23 + pro6F2Payment.mar23 + pro6F3Payment.mar23
]
export const pro6WithMar23Count = [
    pro6F1Collectable.mar23,
    pro6F2Collectable.mar23,
    pro6F3Collectable.mar23,
    pro6F1Collectable.mar23 + pro6F2Collectable.mar23 + pro6F3Collectable.mar23
]
export const pro6WithMar23NonCount = [
    pro6F1NonCollectable.mar23,
    pro6F2NonCollectable.mar23,
    pro6F3NonCollectable.mar23,
    pro6F1NonCollectable.mar23 + pro6F2NonCollectable.mar23 + pro6F3NonCollectable.mar23
]
export const pro6WithMar23Claim = [
    pro6F1ClaimCount.mar23,
    pro6F2ClaimCount.mar23,
    pro6F3ClaimCount.mar23,
    pro6F1ClaimCount.mar23 + pro6F2ClaimCount.mar23 + pro6F3ClaimCount.mar23
]
export const pro6WithMar23PerVisit = [
    pro6F1PerVisit.mar23,
    pro6F2PerVisit.mar23,
    pro6F3PerVisit.mar23,
    provider6PerVisist[26]
]
// april 23
export const pro6WithApr23Charges = [
    pro6F1Charge.apr23,
    pro6F2Charge.apr23,
    pro6F3Charge.apr23,
    pro6F1Charge.apr23 + pro6F2Charge.apr23 + pro6F3Charge.apr23
]
export const pro6WithApr23Pay = [
    pro6F1Payment.apr23,
    pro6F2Payment.apr23,
    pro6F3Payment.apr23,
    pro6F1Payment.apr23 + pro6F2Payment.apr23 + pro6F3Payment.apr23
]
export const pro6WithApr23Count = [
    pro6F1Collectable.apr23,
    pro6F2Collectable.apr23,
    pro6F3Collectable.apr23,
    pro6F1Collectable.apr23 + pro6F2Collectable.apr23 + pro6F3Collectable.apr23
]
export const pro6WithApr23NonCount = [
    pro6F1NonCollectable.apr23,
    pro6F2NonCollectable.apr23,
    pro6F3NonCollectable.apr23,
    pro6F1NonCollectable.apr23 + pro6F2NonCollectable.apr23 + pro6F3NonCollectable.apr23
]
export const pro6WithApr23Claim = [
    pro6F1ClaimCount.apr23,
    pro6F2ClaimCount.apr23,
    pro6F3ClaimCount.apr23,
    pro6F1ClaimCount.apr23 + pro6F2ClaimCount.apr23 + pro6F3ClaimCount.apr23
]
export const pro6WithApr23PerVisit = [
    pro6F1PerVisit.apr23,
    pro6F2PerVisit.apr23,
    pro6F3PerVisit.apr23,
    provider6PerVisist[27]
]
// may 23
export const pro6WithMay23Charges = [
    pro6F1Charge.may23,
    pro6F2Charge.may23,
    pro6F3Charge.may23,
    pro6F1Charge.may23 + pro6F2Charge.may23 + pro6F3Charge.may23
]
export const pro6WithMay23Pay = [
    pro6F1Payment.may23,
    pro6F2Payment.may23,
    pro6F3Payment.may23,
    pro6F1Payment.may23 + pro6F2Payment.may23 + pro6F3Payment.may23
]
export const pro6WithMay23Count = [
    pro6F1Collectable.may23,
    pro6F2Collectable.may23,
    pro6F3Collectable.may23,
    pro6F1Collectable.may23 + pro6F2Collectable.may23 + pro6F3Collectable.may23
]
export const pro6WithMay23NonCount = [
    pro6F1NonCollectable.may23,
    pro6F2NonCollectable.may23,
    pro6F3NonCollectable.may23,
    pro6F1NonCollectable.may23 + pro6F2NonCollectable.may23 + pro6F3NonCollectable.may23
]
export const pro6WithMay23Claim = [
    pro6F1ClaimCount.may23,
    pro6F2ClaimCount.may23,
    pro6F3ClaimCount.may23,
    pro6F1ClaimCount.may23 + pro6F2ClaimCount.may23 + pro6F3ClaimCount.may23
]
export const pro6WithMay23PerVisit = [
    pro6F1PerVisit.may23,
    pro6F2PerVisit.may23,
    pro6F3PerVisit.may23,
    provider6PerVisist[28]
]
// jun 23
export const pro6WithJun23Charges = [
    pro6F1Charge.jun23,
    pro6F2Charge.jun23,
    pro6F3Charge.jun23,
    pro6F1Charge.jun23 + pro6F2Charge.jun23 + pro6F3Charge.jun23
]
export const pro6WithJun23Pay = [
    pro6F1Payment.jun23,
    pro6F2Payment.jun23,
    pro6F3Payment.jun23,
    pro6F1Payment.jun23 + pro6F2Payment.jun23 + pro6F3Payment.jun23
]
export const pro6WithJun23Count = [
    pro6F1Collectable.jun23,
    pro6F2Collectable.jun23,
    pro6F3Collectable.jun23,
    pro6F1Collectable.jun23 + pro6F2Collectable.jun23 + pro6F3Collectable.jun23
]
export const pro6WithJun23NonCount = [
    pro6F1NonCollectable.jun23,
    pro6F2NonCollectable.jun23,
    pro6F3NonCollectable.jun23,
    pro6F1NonCollectable.jun23 + pro6F2NonCollectable.jun23 + pro6F3NonCollectable.jun23
]
export const pro6WithJun23Claim = [
    pro6F1ClaimCount.jun23,
    pro6F2ClaimCount.jun23,
    pro6F3ClaimCount.jun23,
    pro6F1ClaimCount.jun23 + pro6F2ClaimCount.jun23 + pro6F3ClaimCount.jun23
]
export const pro6WithJun23PerVisit = [
    pro6F1PerVisit.jun23,
    pro6F2PerVisit.jun23,
    pro6F3PerVisit.jun23,
    provider6PerVisist[29]
]
// jul 23
export const pro6WithJul23Charges = [
    pro6F1Charge.jul23,
    pro6F2Charge.jul23,
    pro6F3Charge.jul23,
    pro6F1Charge.jul23 + pro6F2Charge.jul23 + pro6F3Charge.jul23
]
export const pro6WithJul23Pay = [
    pro6F1Payment.jul23,
    pro6F2Payment.jul23,
    pro6F3Payment.jul23,
    pro6F1Payment.jul23 + pro6F2Payment.jul23 + pro6F3Payment.jul23
]
export const pro6WithJul23Count = [
    pro6F1Collectable.jul23,
    pro6F2Collectable.jul23,
    pro6F3Collectable.jul23,
    pro6F1Collectable.jul23 + pro6F2Collectable.jul23 + pro6F3Collectable.jul23
]
export const pro6WithJul23NonCount = [
    pro6F1NonCollectable.jul23,
    pro6F2NonCollectable.jul23,
    pro6F3NonCollectable.jul23,
    pro6F1NonCollectable.jul23 + pro6F2NonCollectable.jul23 + pro6F3NonCollectable.jul23
]
export const pro6WithJul23Claim = [
    pro6F1ClaimCount.jul23,
    pro6F2ClaimCount.jul23,
    pro6F3ClaimCount.jul23,
    pro6F1ClaimCount.jul23 + pro6F2ClaimCount.jul23 + pro6F3ClaimCount.jul23
]
export const pro6WithJul23PerVisit = [
    pro6F1PerVisit.jul23,
    pro6F2PerVisit.jul23,
    pro6F3PerVisit.jul23,
    provider6PerVisist[30]
]
// aug 23
export const pro6WithAug23Charges = [
    pro6F1Charge.aug23,
    pro6F2Charge.aug23,
    pro6F3Charge.aug23,
    pro6F1Charge.aug23 + pro6F2Charge.aug23 + pro6F3Charge.aug23
]
export const pro6WithAug23Pay = [
    pro6F1Payment.aug23,
    pro6F2Payment.aug23,
    pro6F3Payment.aug23,
    pro6F1Payment.aug23 + pro6F2Payment.aug23 + pro6F3Payment.aug23
]
export const pro6WithAug23Count = [
    pro6F1Collectable.aug23,
    pro6F2Collectable.aug23,
    pro6F3Collectable.aug23,
    pro6F1Collectable.aug23 + pro6F2Collectable.aug23 + pro6F3Collectable.aug23
]
export const pro6WithAug23NonCount = [
    pro6F1NonCollectable.aug23,
    pro6F2NonCollectable.aug23,
    pro6F3NonCollectable.aug23,
    pro6F1NonCollectable.aug23 + pro6F2NonCollectable.aug23 + pro6F3NonCollectable.aug23
]
export const pro6WithAug23Claim = [
    pro6F1ClaimCount.aug23,
    pro6F2ClaimCount.aug23,
    pro6F3ClaimCount.aug23,
    pro6F1ClaimCount.aug23 + pro6F2ClaimCount.aug23 + pro6F3ClaimCount.aug23
]
export const pro6WithAug23PerVisit = [
    pro6F1PerVisit.aug23,
    pro6F2PerVisit.aug23,
    pro6F3PerVisit.aug23,
    provider6PerVisist[31]
]
// sep 23
export const pro6WithSep23Charges = [
    pro6F1Charge.sep23,
    pro6F2Charge.sep23,
    pro6F3Charge.sep23,
    pro6F1Charge.sep23 + pro6F2Charge.sep23 + pro6F3Charge.sep23
]
export const pro6WithSep23Pay = [
    pro6F1Payment.sep23,
    pro6F2Payment.sep23,
    pro6F3Payment.sep23,
    pro6F1Payment.sep23 + pro6F2Payment.sep23 + pro6F3Payment.sep23
]
export const pro6WithSep23Count = [
    pro6F1Collectable.sep23,
    pro6F2Collectable.sep23,
    pro6F3Collectable.sep23,
    pro6F1Collectable.sep23 + pro6F2Collectable.sep23 + pro6F3Collectable.sep23
]
export const pro6WithSep23NonCount = [
    pro6F1NonCollectable.sep23,
    pro6F2NonCollectable.sep23,
    pro6F3NonCollectable.sep23,
    pro6F1NonCollectable.sep23 + pro6F2NonCollectable.sep23 + pro6F3NonCollectable.sep23
]
export const pro6WithSep23Claim = [
    pro6F1ClaimCount.sep23,
    pro6F2ClaimCount.sep23,
    pro6F3ClaimCount.sep23,
    pro6F1ClaimCount.sep23 + pro6F2ClaimCount.sep23 + pro6F3ClaimCount.sep23
]
export const pro6WithSep23PerVisit = [
    pro6F1PerVisit.sep23,
    pro6F2PerVisit.sep23,
    pro6F3PerVisit.sep23,
    provider6PerVisist[32]
]
// oct 23
export const pro6WithOct23Charges = [
    pro6F1Charge.oct23,
    pro6F2Charge.oct23,
    pro6F3Charge.oct23,
    pro6F1Charge.oct23 + pro6F2Charge.oct23 + pro6F3Charge.oct23
]
export const pro6WithOct23Pay = [
    pro6F1Payment.oct23,
    pro6F2Payment.oct23,
    pro6F3Payment.oct23,
    pro6F1Payment.oct23 + pro6F2Payment.oct23 + pro6F3Payment.oct23
]
export const pro6WithOct23Count = [
    pro6F1Collectable.oct23,
    pro6F2Collectable.oct23,
    pro6F3Collectable.oct23,
    pro6F1Collectable.oct23 + pro6F2Collectable.oct23 + pro6F3Collectable.oct23
]
export const pro6WithOct23NonCount = [
    pro6F1NonCollectable.oct23,
    pro6F2NonCollectable.oct23,
    pro6F3NonCollectable.oct23,
    pro6F1NonCollectable.oct23 + pro6F2NonCollectable.oct23 + pro6F3NonCollectable.oct23
]
export const pro6WithOct23Claim = [
    pro6F1ClaimCount.oct23,
    pro6F2ClaimCount.oct23,
    pro6F3ClaimCount.oct23,
    pro6F1ClaimCount.oct23 + pro6F2ClaimCount.oct23 + pro6F3ClaimCount.oct23
]
export const pro6WithOct23PerVisit = [
    pro6F1PerVisit.oct23,
    pro6F2PerVisit.oct23,
    pro6F3PerVisit.oct23,
    provider6PerVisist[33]
]
// nov 23
export const pro6WithNov23Charges = [
    pro6F1Charge.nov23,
    pro6F2Charge.nov23,
    pro6F3Charge.nov23,
    pro6F1Charge.nov23 + pro6F2Charge.nov23 + pro6F3Charge.nov23
]
export const pro6WithNov23Pay = [
    pro6F1Payment.nov23,
    pro6F2Payment.nov23,
    pro6F3Payment.nov23,
    pro6F1Payment.nov23 +
    pro6F2Payment.nov23 + 
    pro6F3Payment.nov23
]
export const pro6WithNov23Count = [
    pro6F1Collectable.nov23,
    pro6F2Collectable.nov23,
    pro6F3Collectable.nov23,
    pro6F1Collectable.nov23 +
    pro6F2Collectable.nov23 +
    pro6F3Collectable.nov23
]
export const pro6WithNov23NonCount = [
    pro6F1NonCollectable.nov23,
    pro6F2NonCollectable.nov23,
    pro6F3NonCollectable.nov23,
    pro6F1NonCollectable.nov23+
    pro6F2NonCollectable.nov23+
    pro6F3NonCollectable.nov23
]
export const pro6WithNov23Claim = [
    pro6F1ClaimCount.nov23,
    pro6F2ClaimCount.nov23,
    pro6F3ClaimCount.nov23,
    pro6F1ClaimCount.nov23 + pro6F2ClaimCount.nov23 + pro6F3ClaimCount.nov23
]
export const pro6WithNov23PerVisit = [
    pro6F1PerVisit.nov23,
    pro6F2PerVisit.nov23,
    pro6F3PerVisit.nov23,
    provider6PerVisist[34]
]
// comm
    // export const pro6WithJan21Charges = [
    //     pro6F1Charge.jan21,
    //     pro6F2Charge.jan21,
    //     pro6F3Charge.jan21
    // ]
    // export const pro6WithJan21Pay = [
    //     pro6F1Payment.jan21,
    //     pro6F2Payment.jan21,
    //     pro6F3Payment.jan21
    // ]
    // export const pro6WithJan21Count = [
    //     pro6F1Collectable.jan21,
    //     pro6F2Collectable.jan21,
    //     pro6F3Collectable.jan21
    // ]
    // export const pro6WithJan21NonCount = [
    //     pro6F1NonCollectable.jan21,
    //     pro6F2NonCollectable.jan21,
    //     pro6F3NonCollectable.jan21
    // ]
    // export const pro6WithJan21Claim = [
    //     pro6F1ClaimCount.jan21,
    //     pro6F2ClaimCount.jan21,
    //     pro6F3ClaimCount.jan21
    // ]
    // export const pro6WithJan21PerVisit = [
    //     pro6F1PerVisit.jan21,
    //     pro6F2PerVisit.jan21,
    //     pro6F3PerVisit.jan21
    // ]
    // // feb 21
    // export const pro6WithFeb21Charges = [
    //     pro6F1Charge.feb21,
    //     pro6F2Charge.feb21,
    //     pro6F3Charge.feb21
    // ]
    // export const pro6WithFeb21Pay = [
    //     pro6F1Payment.feb21,
    //     pro6F2Payment.feb21,
    //     pro6F3Payment.feb21
    // ]
    // export const pro6WithFeb21Count = [
    //     pro6F1Collectable.feb21,
    //     pro6F2Collectable.feb21,
    //     pro6F3Collectable.feb21
    // ]
    // export const pro6WithFeb21NonCount = [
    //     pro6F1NonCollectable.feb21,
    //     pro6F2NonCollectable.feb21,
    //     pro6F3NonCollectable.feb21
    // ]
    // export const pro6WithFeb21Claim = [
    //     pro6F1ClaimCount.feb21,
    //     pro6F2ClaimCount.feb21,
    //     pro6F3ClaimCount.feb21
    // ]
    // export const pro6WithFeb21PerVisit = [
    //     pro6F1PerVisit.feb21,
    //     pro6F2PerVisit.feb21,
    //     pro6F3PerVisit.feb21
    // ]
    // // mar 21
    // export const pro6WithMar21Charges = [
    //     pro6F1Charge.mar21,
    //     pro6F2Charge.mar21,
    //     pro6F3Charge.mar21
    // ]
    // export const pro6WithMar21Pay = [
    //     pro6F1Payment.mar21,
    //     pro6F2Payment.mar21,
    //     pro6F3Payment.mar21
    // ]
    // export const pro6WithMar21Count = [
    //     pro6F1Collectable.mar21,
    //     pro6F2Collectable.mar21,
    //     pro6F3Collectable.mar21
    // ]
    // export const pro6WithMar21NonCount = [
    //     pro6F1NonCollectable.mar21,
    //     pro6F2NonCollectable.mar21,
    //     pro6F3NonCollectable.mar21
    // ]
    // export const pro6WithMar21Claim = [
    //     pro6F1ClaimCount.mar21,
    //     pro6F2ClaimCount.mar21,
    //     pro6F3ClaimCount.mar21
    // ]
    // export const pro6WithMar21PerVisit = [
    //     pro6F1PerVisit.mar21,
    //     pro6F2PerVisit.mar21,
    //     pro6F3PerVisit.mar21
    // ]
    // // april 21
    // export const pro6WithApr21Charges = [
    //     pro6F1Charge.apr21,
    //     pro6F2Charge.apr21,
    //     pro6F3Charge.apr21
    // ]
    // export const pro6WithApr21Pay = [
    //     pro6F1Payment.apr21,
    //     pro6F2Payment.apr21,
    //     pro6F3Payment.apr21
    // ]
    // export const pro6WithApr21Count = [
    //     pro6F1Collectable.apr21,
    //     pro6F2Collectable.apr21,
    //     pro6F3Collectable.apr21
    // ]
    // export const pro6WithApr21NonCount = [
    //     pro6F1NonCollectable.apr21,
    //     pro6F2NonCollectable.apr21,
    //     pro6F3NonCollectable.apr21
    // ]
    // export const pro6WithApr21Claim = [
    //     pro6F1ClaimCount.apr21,
    //     pro6F2ClaimCount.apr21,
    //     pro6F3ClaimCount.apr21
    // ]
    // export const pro6WithApr21PerVisit = [
    //     pro6F1PerVisit.apr21,
    //     pro6F2PerVisit.apr21,
    //     pro6F3PerVisit.apr21
    // ]
    // // may 21
    // export const pro6WithMay21Charges = [
    //     pro6F1Charge.may21,
    //     pro6F2Charge.may21,
    //     pro6F3Charge.may21
    // ]
    // export const pro6WithMay21Pay = [
    //     pro6F1Payment.may21,
    //     pro6F2Payment.may21,
    //     pro6F3Payment.may21
    // ]
    // export const pro6WithMay21Count = [
    //     pro6F1Collectable.may21,
    //     pro6F2Collectable.may21,
    //     pro6F3Collectable.may21
    // ]
    // export const pro6WithMay21NonCount = [
    //     pro6F1NonCollectable.may21,
    //     pro6F2NonCollectable.may21,
    //     pro6F3NonCollectable.may21
    // ]
    // export const pro6WithMay21Claim = [
    //     pro6F1ClaimCount.may21,
    //     pro6F2ClaimCount.may21,
    //     pro6F3ClaimCount.may21
    // ]
    // export const pro6WithMay21PerVisit = [
    //     pro6F1PerVisit.may21,
    //     pro6F2PerVisit.may21,
    //     pro6F3PerVisit.may21
    // ]
    // // jun 21
    // export const pro6WithJun21Charges = [
    //     pro6F1Charge.jun21,
    //     pro6F2Charge.jun21,
    //     pro6F3Charge.jun21
    // ]
    // export const pro6WithJun21Pay = [
    //     pro6F1Payment.jun21,
    //     pro6F2Payment.jun21,
    //     pro6F3Payment.jun21
    // ]
    // export const pro6WithJun21Count = [
    //     pro6F1Collectable.jun21,
    //     pro6F2Collectable.jun21,
    //     pro6F3Collectable.jun21
    // ]
    // export const pro6WithJun21NonCount = [
    //     pro6F1NonCollectable.jun21,
    //     pro6F2NonCollectable.jun21,
    //     pro6F3NonCollectable.jun21
    // ]
    // export const pro6WithJun21Claim = [
    //     pro6F1ClaimCount.jun21,
    //     pro6F2ClaimCount.jun21,
    //     pro6F3ClaimCount.jun21
    // ]
    // export const pro6WithJun21PerVisit = [
    //     pro6F1PerVisit.jun21,
    //     pro6F2PerVisit.jun21,
    //     pro6F3PerVisit.jun21
    // ]
    // // jul 21
    // export const pro6WithJul21Charges = [
    //     pro6F1Charge.jul21,
    //     pro6F2Charge.jul21,
    //     pro6F3Charge.jul21
    // ]
    // export const pro6WithJul21Pay = [
    //     pro6F1Payment.jul21,
    //     pro6F2Payment.jul21,
    //     pro6F3Payment.jul21
    // ]
    // export const pro6WithJul21Count = [
    //     pro6F1Collectable.jul21,
    //     pro6F2Collectable.jul21,
    //     pro6F3Collectable.jul21
    // ]
    // export const pro6WithJul21NonCount = [
    //     pro6F1NonCollectable.jul21,
    //     pro6F2NonCollectable.jul21,
    //     pro6F3NonCollectable.jul21
    // ]
    // export const pro6WithJul21Claim = [
    //     pro6F1ClaimCount.jul21,
    //     pro6F2ClaimCount.jul21,
    //     pro6F3ClaimCount.jul21
    // ]
    // export const pro6WithJul21PerVisit = [
    //     pro6F1PerVisit.jul21,
    //     pro6F2PerVisit.jul21,
    //     pro6F3PerVisit.jul21
    // ]
    // // aug 21
    // export const pro6WithAug21Charges = [
    //     pro6F1Charge.aug21,
    //     pro6F2Charge.aug21,
    //     pro6F3Charge.aug21
    // ]
    // export const pro6WithAug21Pay = [
    //     pro6F1Payment.aug21,
    //     pro6F2Payment.aug21,
    //     pro6F3Payment.aug21
    // ]
    // export const pro6WithAug21Count = [
    //     pro6F1Collectable.aug21,
    //     pro6F2Collectable.aug21,
    //     pro6F3Collectable.aug21
    // ]
    // export const pro6WithAug21NonCount = [
    //     pro6F1NonCollectable.aug21,
    //     pro6F2NonCollectable.aug21,
    //     pro6F3NonCollectable.aug21
    // ]
    // export const pro6WithAug21Claim = [
    //     pro6F1ClaimCount.aug21,
    //     pro6F2ClaimCount.aug21,
    //     pro6F3ClaimCount.aug21
    // ]
    // export const pro6WithAug21PerVisit = [
    //     pro6F1PerVisit.aug21,
    //     pro6F2PerVisit.aug21,
    //     pro6F3PerVisit.aug21
    // ]
    // // sep 21
    // export const pro6WithSep21Charges = [
    //     pro6F1Charge.sep21,
    //     pro6F2Charge.sep21,
    //     pro6F3Charge.sep21
    // ]
    // export const pro6WithSep21Pay = [
    //     pro6F1Payment.sep21,
    //     pro6F2Payment.sep21,
    //     pro6F3Payment.sep21
    // ]
    // export const pro6WithSep21Count = [
    //     pro6F1Collectable.sep21,
    //     pro6F2Collectable.sep21,
    //     pro6F3Collectable.sep21
    // ]
    // export const pro6WithSep21NonCount = [
    //     pro6F1NonCollectable.sep21,
    //     pro6F2NonCollectable.sep21,
    //     pro6F3NonCollectable.sep21
    // ]
    // export const pro6WithSep21Claim = [
    //     pro6F1ClaimCount.sep21,
    //     pro6F2ClaimCount.sep21,
    //     pro6F3ClaimCount.sep21
    // ]
    // export const pro6WithSep21PerVisit = [
    //     pro6F1PerVisit.sep21,
    //     pro6F2PerVisit.sep21,
    //     pro6F3PerVisit.sep21
    // ]
    // // oct 21
    // export const pro6WithOct21Charges = [
    //     pro6F1Charge.oct21,
    //     pro6F2Charge.oct21,
    //     pro6F3Charge.oct21
    // ]
    // export const pro6WithOct21Pay = [
    //     pro6F1Payment.oct21,
    //     pro6F2Payment.oct21,
    //     pro6F3Payment.oct21
    // ]
    // export const pro6WithOct21Count = [
    //     pro6F1Collectable.oct21,
    //     pro6F2Collectable.oct21,
    //     pro6F3Collectable.oct21
    // ]
    // export const pro6WithOct21NonCount = [
    //     pro6F1NonCollectable.oct21,
    //     pro6F2NonCollectable.oct21,
    //     pro6F3NonCollectable.oct21
    // ]
    // export const pro6WithOct21Claim = [
    //     pro6F1ClaimCount.oct21,
    //     pro6F2ClaimCount.oct21,
    //     pro6F3ClaimCount.oct21
    // ]
    // export const pro6WithOct21PerVisit = [
    //     pro6F1PerVisit.oct21,
    //     pro6F2PerVisit.oct21,
    //     pro6F3PerVisit.oct21
    // ]
    // // nov 21
    // export const pro6WithNov21Charges = [
    //     pro6F1Charge.nov21,
    //     pro6F2Charge.nov21,
    //     pro6F3Charge.nov21
    // ]
    // export const pro6WithNov21Pay = [
    //     pro6F1Payment.nov21,
    //     pro6F2Payment.nov21,
    //     pro6F3Payment.nov21
    // ]
    // export const pro6WithNov21Count = [
    //     pro6F1Collectable.nov21,
    //     pro6F2Collectable.nov21,
    //     pro6F3Collectable.nov21
    // ]
    // export const pro6WithNov21NonCount = [
    //     pro6F1NonCollectable.nov21,
    //     pro6F2NonCollectable.nov21,
    //     pro6F3NonCollectable.nov21
    // ]
    // export const pro6WithNov21Claim = [
    //     pro6F1ClaimCount.nov21,
    //     pro6F2ClaimCount.nov21,
    //     pro6F3ClaimCount.nov21
    // ]
    // export const pro6WithNov21PerVisit = [
    //     pro6F1PerVisit.nov21,
    //     pro6F2PerVisit.nov21,
    //     pro6F3PerVisit.nov21
    // ]
    // // dec 21
    // export const pro6WithDec21Charges = [
    //     pro6F1Charge.dec21,
    //     pro6F2Charge.dec21,
    //     pro6F3Charge.dec21
    // ]
    // export const pro6WithDec21Pay = [
    //     pro6F1Payment.dec21,
    //     pro6F2Payment.dec21,
    //     pro6F3Payment.dec21
    // ]
    // export const pro6WithDec21Count = [
    //     pro6F1Collectable.dec21,
    //     pro6F2Collectable.dec21,
    //     pro6F3Collectable.dec21
    // ]
    // export const pro6WithDec21NonCount = [
    //     pro6F1NonCollectable.dec21,
    //     pro6F2NonCollectable.dec21,
    //     pro6F3NonCollectable.dec21
    // ]
    // export const pro6WithDec21Claim = [
    //     pro6F1ClaimCount.dec21,
    //     pro6F2ClaimCount.dec21,
    //     pro6F3ClaimCount.dec21
    // ]
    // export const pro6WithDec21PerVisit = [
    //     pro6F1PerVisit.dec21,
    //     pro6F2PerVisit.dec21,
    //     pro6F3PerVisit.dec21
    // ]
    
    // // provider-6
    // // jan 22
    // export const pro6WithJan22Charges = [
    //     pro6F1Charge.jan22,
    //     pro6F2Charge.jan22,
    //     pro6F3Charge.jan22
    // ]
    // export const pro6WithJan22Pay = [
    //     pro6F1Payment.jan22,
    //     pro6F2Payment.jan22,
    //     pro6F3Payment.jan22
    // ]
    // export const pro6WithJan22Count = [
    //     pro6F1Collectable.jan22,
    //     pro6F2Collectable.jan22,
    //     pro6F3Collectable.jan22
    // ]
    // export const pro6WithJan22NonCount = [
    //     pro6F1NonCollectable.jan22,
    //     pro6F2NonCollectable.jan22,
    //     pro6F3NonCollectable.jan22
    // ]
    // export const pro6WithJan22Claim = [
    //     pro6F1ClaimCount.jan22,
    //     pro6F2ClaimCount.jan22,
    //     pro6F3ClaimCount.jan22
    // ]
    // export const pro6WithJan22PerVisit = [
    //     pro6F1PerVisit.jan22,
    //     pro6F2PerVisit.jan22,
    //     pro6F3PerVisit.jan22
    // ]
    // // feb 22
    // export const pro6WithFeb22Charges = [
    //     pro6F1Charge.feb22,
    //     pro6F2Charge.feb22,
    //     pro6F3Charge.feb22
    // ]
    // export const pro6WithFeb22Pay = [
    //     pro6F1Payment.feb22,
    //     pro6F2Payment.feb22,
    //     pro6F3Payment.feb22
    // ]
    // export const pro6WithFeb22Count = [
    //     pro6F1Collectable.feb22,
    //     pro6F2Collectable.feb22,
    //     pro6F3Collectable.feb22
    // ]
    // export const pro6WithFeb22NonCount = [
    //     pro6F1NonCollectable.feb22,
    //     pro6F2NonCollectable.feb22,
    //     pro6F3NonCollectable.feb22
    // ]
    // export const pro6WithFeb22Claim = [
    //     pro6F1ClaimCount.feb22,
    //     pro6F2ClaimCount.feb22,
    //     pro6F3ClaimCount.feb22
    // ]
    // export const pro6WithFeb22PerVisit = [
    //     pro6F1PerVisit.feb22,
    //     pro6F2PerVisit.feb22,
    //     pro6F3PerVisit.feb22
    // ]
    // // mar 22
    // export const pro6WithMar22Charges = [
    //     pro6F1Charge.mar22,
    //     pro6F2Charge.mar22,
    //     pro6F3Charge.mar22
    // ]
    // export const pro6WithMar22Pay = [
    //     pro6F1Payment.mar22,
    //     pro6F2Payment.mar22,
    //     pro6F3Payment.mar22
    // ]
    // export const pro6WithMar22Count = [
    //     pro6F1Collectable.mar22,
    //     pro6F2Collectable.mar22,
    //     pro6F3Collectable.mar22
    // ]
    // export const pro6WithMar22NonCount = [
    //     pro6F1NonCollectable.mar22,
    //     pro6F2NonCollectable.mar22,
    //     pro6F3NonCollectable.mar22
    // ]
    // export const pro6WithMar22Claim = [
    //     pro6F1ClaimCount.mar22,
    //     pro6F2ClaimCount.mar22,
    //     pro6F3ClaimCount.mar22
    // ]
    // export const pro6WithMar22PerVisit = [
    //     pro6F1PerVisit.mar22,
    //     pro6F2PerVisit.mar22,
    //     pro6F3PerVisit.mar22
    // ]
    // // april 22
    // export const pro6WithApr22Charges = [
    //     pro6F1Charge.apr22,
    //     pro6F2Charge.apr22,
    //     pro6F3Charge.apr22
    // ]
    // export const pro6WithApr22Pay = [
    //     pro6F1Payment.apr22,
    //     pro6F2Payment.apr22,
    //     pro6F3Payment.apr22
    // ]
    // export const pro6WithApr22Count = [
    //     pro6F1Collectable.apr22,
    //     pro6F2Collectable.apr22,
    //     pro6F3Collectable.apr22
    // ]
    // export const pro6WithApr22NonCount = [
    //     pro6F1NonCollectable.apr22,
    //     pro6F2NonCollectable.apr22,
    //     pro6F3NonCollectable.apr22
    // ]
    // export const pro6WithApr22Claim = [
    //     pro6F1ClaimCount.apr22,
    //     pro6F2ClaimCount.apr22,
    //     pro6F3ClaimCount.apr22
    // ]
    // export const pro6WithApr22PerVisit = [
    //     pro6F1PerVisit.apr22,
    //     pro6F2PerVisit.apr22,
    //     pro6F3PerVisit.apr22
    // ]
    // // may 22
    // export const pro6WithMay22Charges = [
    //     pro6F1Charge.may22,
    //     pro6F2Charge.may22,
    //     pro6F3Charge.may22
    // ]
    // export const pro6WithMay22Pay = [
    //     pro6F1Payment.may22,
    //     pro6F2Payment.may22,
    //     pro6F3Payment.may22
    // ]
    // export const pro6WithMay22Count = [
    //     pro6F1Collectable.may22,
    //     pro6F2Collectable.may22,
    //     pro6F3Collectable.may22
    // ]
    // export const pro6WithMay22NonCount = [
    //     pro6F1NonCollectable.may22,
    //     pro6F2NonCollectable.may22,
    //     pro6F3NonCollectable.may22
    // ]
    // export const pro6WithMay22Claim = [
    //     pro6F1ClaimCount.may22,
    //     pro6F2ClaimCount.may22,
    //     pro6F3ClaimCount.may22
    // ]
    // export const pro6WithMay22PerVisit = [
    //     pro6F1PerVisit.may22,
    //     pro6F2PerVisit.may22,
    //     pro6F3PerVisit.may22
    // ]
    // // jun 22
    // export const pro6WithJun22Charges = [
    //     pro6F1Charge.jun22,
    //     pro6F2Charge.jun22,
    //     pro6F3Charge.jun22
    // ]
    // export const pro6WithJun22Pay = [
    //     pro6F1Payment.jun22,
    //     pro6F2Payment.jun22,
    //     pro6F3Payment.jun22
    // ]
    // export const pro6WithJun22Count = [
    //     pro6F1Collectable.jun22,
    //     pro6F2Collectable.jun22,
    //     pro6F3Collectable.jun22
    // ]
    // export const pro6WithJun22NonCount = [
    //     pro6F1NonCollectable.jun22,
    //     pro6F2NonCollectable.jun22,
    //     pro6F3NonCollectable.jun22
    // ]
    // export const pro6WithJun22Claim = [
    //     pro6F1ClaimCount.jun22,
    //     pro6F2ClaimCount.jun22,
    //     pro6F3ClaimCount.jun22
    // ]
    // export const pro6WithJun22PerVisit = [
    //     pro6F1PerVisit.jun22,
    //     pro6F2PerVisit.jun22,
    //     pro6F3PerVisit.jun22
    // ]
    // // jul 22
    // export const pro6WithJul22Charges = [
    //     pro6F1Charge.jul22,
    //     pro6F2Charge.jul22,
    //     pro6F3Charge.jul22
    // ]
    // export const pro6WithJul22Pay = [
    //     pro6F1Payment.jul22,
    //     pro6F2Payment.jul22,
    //     pro6F3Payment.jul22
    // ]
    // export const pro6WithJul22Count = [
    //     pro6F1Collectable.jul22,
    //     pro6F2Collectable.jul22,
    //     pro6F3Collectable.jul22
    // ]
    // export const pro6WithJul22NonCount = [
    //     pro6F1NonCollectable.jul22,
    //     pro6F2NonCollectable.jul22,
    //     pro6F3NonCollectable.jul22
    // ]
    // export const pro6WithJul22Claim = [
    //     pro6F1ClaimCount.jul22,
    //     pro6F2ClaimCount.jul22,
    //     pro6F3ClaimCount.jul22
    // ]
    // export const pro6WithJul22PerVisit = [
    //     pro6F1PerVisit.jul22,
    //     pro6F2PerVisit.jul22,
    //     pro6F3PerVisit.jul22
    // ]
    // // aug 22
    // export const pro6WithAug22Charges = [
    //     pro6F1Charge.aug22,
    //     pro6F2Charge.aug22,
    //     pro6F3Charge.aug22
    // ]
    // export const pro6WithAug22Pay = [
    //     pro6F1Payment.aug22,
    //     pro6F2Payment.aug22,
    //     pro6F3Payment.aug22
    // ]
    // export const pro6WithAug22Count = [
    //     pro6F1Collectable.aug22,
    //     pro6F2Collectable.aug22,
    //     pro6F3Collectable.aug22
    // ]
    // export const pro6WithAug22NonCount = [
    //     pro6F1NonCollectable.aug22,
    //     pro6F2NonCollectable.aug22,
    //     pro6F3NonCollectable.aug22
    // ]
    // export const pro6WithAug22Claim = [
    //     pro6F1ClaimCount.aug22,
    //     pro6F2ClaimCount.aug22,
    //     pro6F3ClaimCount.aug22
    // ]
    // export const pro6WithAug22PerVisit = [
    //     pro6F1PerVisit.aug22,
    //     pro6F2PerVisit.aug22,
    //     pro6F3PerVisit.aug22
    // ]
    // // sep 22
    // export const pro6WithSep22Charges = [
    //     pro6F1Charge.sep22,
    //     pro6F2Charge.sep22,
    //     pro6F3Charge.sep22
    // ]
    // export const pro6WithSep22Pay = [
    //     pro6F1Payment.sep22,
    //     pro6F2Payment.sep22,
    //     pro6F3Payment.sep22
    // ]
    // export const pro6WithSep22Count = [
    //     pro6F1Collectable.sep22,
    //     pro6F2Collectable.sep22,
    //     pro6F3Collectable.sep22
    // ]
    // export const pro6WithSep22NonCount = [
    //     pro6F1NonCollectable.sep22,
    //     pro6F2NonCollectable.sep22,
    //     pro6F3NonCollectable.sep22
    // ]
    // export const pro6WithSep22Claim = [
    //     pro6F1ClaimCount.sep22,
    //     pro6F2ClaimCount.sep22,
    //     pro6F3ClaimCount.sep22
    // ]
    // export const pro6WithSep22PerVisit = [
    //     pro6F1PerVisit.sep22,
    //     pro6F2PerVisit.sep22,
    //     pro6F3PerVisit.sep22
    // ]
    // // oct 22
    // export const pro6WithOct22Charges = [
    //     pro6F1Charge.oct22,
    //     pro6F2Charge.oct22,
    //     pro6F3Charge.oct22
    // ]
    // export const pro6WithOct22Pay = [
    //     pro6F1Payment.oct22,
    //     pro6F2Payment.oct22,
    //     pro6F3Payment.oct22
    // ]
    // export const pro6WithOct22Count = [
    //     pro6F1Collectable.oct22,
    //     pro6F2Collectable.oct22,
    //     pro6F3Collectable.oct22
    // ]
    // export const pro6WithOct22NonCount = [
    //     pro6F1NonCollectable.oct22,
    //     pro6F2NonCollectable.oct22,
    //     pro6F3NonCollectable.oct22
    // ]
    // export const pro6WithOct22Claim = [
    //     pro6F1ClaimCount.oct22,
    //     pro6F2ClaimCount.oct22,
    //     pro6F3ClaimCount.oct22
    // ]
    // export const pro6WithOct22PerVisit = [
    //     pro6F1PerVisit.oct22,
    //     pro6F2PerVisit.oct22,
    //     pro6F3PerVisit.oct22
    // ]
    // // nov 22
    // export const pro6WithNov22Charges = [
    //     pro6F1Charge.nov22,
    //     pro6F2Charge.nov22,
    //     pro6F3Charge.nov22
    // ]
    // export const pro6WithNov22Pay = [
    //     pro6F1Payment.nov22,
    //     pro6F2Payment.nov22,
    //     pro6F3Payment.nov22
    // ]
    // export const pro6WithNov22Count = [
    //     pro6F1Collectable.nov22,
    //     pro6F2Collectable.nov22,
    //     pro6F3Collectable.nov22
    // ]
    // export const pro6WithNov22NonCount = [
    //     pro6F1NonCollectable.nov22,
    //     pro6F2NonCollectable.nov22,
    //     pro6F3NonCollectable.nov22
    // ]
    // export const pro6WithNov22Claim = [
    //     pro6F1ClaimCount.nov22,
    //     pro6F2ClaimCount.nov22,
    //     pro6F3ClaimCount.nov22
    // ]
    // export const pro6WithNov22PerVisit = [
    //     pro6F1PerVisit.nov22,
    //     pro6F2PerVisit.nov22,
    //     pro6F3PerVisit.nov22
    // ]
    // // dec 22
    // export const pro6WithDec22Charges = [
    //     pro6F1Charge.dec22,
    //     pro6F2Charge.dec22,
    //     pro6F3Charge.dec22
    // ]
    // export const pro6WithDec22Pay = [
    //     pro6F1Payment.dec22,
    //     pro6F2Payment.dec22,
    //     pro6F3Payment.dec22
    // ]
    // export const pro6WithDec22Count = [
    //     pro6F1Collectable.dec22,
    //     pro6F2Collectable.dec22,
    //     pro6F3Collectable.dec22
    // ]
    // export const pro6WithDec22NonCount = [
    //     pro6F1NonCollectable.dec22,
    //     pro6F2NonCollectable.dec22,
    //     pro6F3NonCollectable.dec22
    // ]
    // export const pro6WithDec22Claim = [
    //     pro6F1ClaimCount.dec22,
    //     pro6F2ClaimCount.dec22,
    //     pro6F3ClaimCount.dec22
    // ]
    // export const pro6WithDec22PerVisit = [
    //     pro6F1PerVisit.dec22,
    //     pro6F2PerVisit.dec22,
    //     pro6F3PerVisit.dec22
    // ]
    
    // // provider-6
    // // jan 23
    // export const pro6WithJan23Charges = [
    //     pro6F1Charge.jan23,
    //     pro6F2Charge.jan23,
    //     pro6F3Charge.jan23
    // ]
    // export const pro6WithJan23Pay = [
    //     pro6F1Payment.jan23,
    //     pro6F2Payment.jan23,
    //     pro6F3Payment.jan23
    // ]
    // export const pro6WithJan23Count = [
    //     pro6F1Collectable.jan23,
    //     pro6F2Collectable.jan23,
    //     pro6F3Collectable.jan23
    // ]
    // export const pro6WithJan23NonCount = [
    //     pro6F1NonCollectable.jan23,
    //     pro6F2NonCollectable.jan23,
    //     pro6F3NonCollectable.jan23
    // ]
    // export const pro6WithJan23Claim = [
    //     pro6F1ClaimCount.jan23,
    //     pro6F2ClaimCount.jan23,
    //     pro6F3ClaimCount.jan23
    // ]
    // export const pro6WithJan23PerVisit = [
    //     pro6F1PerVisit.jan23,
    //     pro6F2PerVisit.jan23,
    //     pro6F3PerVisit.jan23
    // ]
    // // feb 23
    // export const pro6WithFeb23Charges = [
    //     pro6F1Charge.feb23,
    //     pro6F2Charge.feb23,
    //     pro6F3Charge.feb23
    // ]
    // export const pro6WithFeb23Pay = [
    //     pro6F1Payment.feb23,
    //     pro6F2Payment.feb23,
    //     pro6F3Payment.feb23
    // ]
    // export const pro6WithFeb23Count = [
    //     pro6F1Collectable.feb23,
    //     pro6F2Collectable.feb23,
    //     pro6F3Collectable.feb23
    // ]
    // export const pro6WithFeb23NonCount = [
    //     pro6F1NonCollectable.feb23,
    //     pro6F2NonCollectable.feb23,
    //     pro6F3NonCollectable.feb23
    // ]
    // export const pro6WithFeb23Claim = [
    //     pro6F1ClaimCount.feb23,
    //     pro6F2ClaimCount.feb23,
    //     pro6F3ClaimCount.feb23
    // ]
    // export const pro6WithFeb23PerVisit = [
    //     pro6F1PerVisit.feb23,
    //     pro6F2PerVisit.feb23,
    //     pro6F3PerVisit.feb23
    // ]
    // // mar 23
    // export const pro6WithMar23Charges = [
    //     pro6F1Charge.mar23,
    //     pro6F2Charge.mar23,
    //     pro6F3Charge.mar23
    // ]
    // export const pro6WithMar23Pay = [
    //     pro6F1Payment.mar23,
    //     pro6F2Payment.mar23,
    //     pro6F3Payment.mar23
    // ]
    // export const pro6WithMar23Count = [
    //     pro6F1Collectable.mar23,
    //     pro6F2Collectable.mar23,
    //     pro6F3Collectable.mar23
    // ]
    // export const pro6WithMar23NonCount = [
    //     pro6F1NonCollectable.mar23,
    //     pro6F2NonCollectable.mar23,
    //     pro6F3NonCollectable.mar23
    // ]
    // export const pro6WithMar23Claim = [
    //     pro6F1ClaimCount.mar23,
    //     pro6F2ClaimCount.mar23,
    //     pro6F3ClaimCount.mar23
    // ]
    // export const pro6WithMar23PerVisit = [
    //     pro6F1PerVisit.mar23,
    //     pro6F2PerVisit.mar23,
    //     pro6F3PerVisit.mar23
    // ]
    // // april 23
    // export const pro6WithApr23Charges = [
    //     pro6F1Charge.apr23,
    //     pro6F2Charge.apr23,
    //     pro6F3Charge.apr23
    // ]
    // export const pro6WithApr23Pay = [
    //     pro6F1Payment.apr23,
    //     pro6F2Payment.apr23,
    //     pro6F3Payment.apr23
    // ]
    // export const pro6WithApr23Count = [
    //     pro6F1Collectable.apr23,
    //     pro6F2Collectable.apr23,
    //     pro6F3Collectable.apr23
    // ]
    // export const pro6WithApr23NonCount = [
    //     pro6F1NonCollectable.apr23,
    //     pro6F2NonCollectable.apr23,
    //     pro6F3NonCollectable.apr23
    // ]
    // export const pro6WithApr23Claim = [
    //     pro6F1ClaimCount.apr23,
    //     pro6F2ClaimCount.apr23,
    //     pro6F3ClaimCount.apr23
    // ]
    // export const pro6WithApr23PerVisit = [
    //     pro6F1PerVisit.apr23,
    //     pro6F2PerVisit.apr23,
    //     pro6F3PerVisit.apr23
    // ]
    // // may 23
    // export const pro6WithMay23Charges = [
    //     pro6F1Charge.may23,
    //     pro6F2Charge.may23,
    //     pro6F3Charge.may23
    // ]
    // export const pro6WithMay23Pay = [
    //     pro6F1Payment.may23,
    //     pro6F2Payment.may23,
    //     pro6F3Payment.may23
    // ]
    // export const pro6WithMay23Count = [
    //     pro6F1Collectable.may23,
    //     pro6F2Collectable.may23,
    //     pro6F3Collectable.may23
    // ]
    // export const pro6WithMay23NonCount = [
    //     pro6F1NonCollectable.may23,
    //     pro6F2NonCollectable.may23,
    //     pro6F3NonCollectable.may23
    // ]
    // export const pro6WithMay23Claim = [
    //     pro6F1ClaimCount.may23,
    //     pro6F2ClaimCount.may23,
    //     pro6F3ClaimCount.may23
    // ]
    // export const pro6WithMay23PerVisit = [
    //     pro6F1PerVisit.may23,
    //     pro6F2PerVisit.may23,
    //     pro6F3PerVisit.may23
    // ]
    // // jun 23
    // export const pro6WithJun23Charges = [
    //     pro6F1Charge.jun23,
    //     pro6F2Charge.jun23,
    //     pro6F3Charge.jun23
    // ]
    // export const pro6WithJun23Pay = [
    //     pro6F1Payment.jun23,
    //     pro6F2Payment.jun23,
    //     pro6F3Payment.jun23
    // ]
    // export const pro6WithJun23Count = [
    //     pro6F1Collectable.jun23,
    //     pro6F2Collectable.jun23,
    //     pro6F3Collectable.jun23
    // ]
    // export const pro6WithJun23NonCount = [
    //     pro6F1NonCollectable.jun23,
    //     pro6F2NonCollectable.jun23,
    //     pro6F3NonCollectable.jun23
    // ]
    // export const pro6WithJun23Claim = [
    //     pro6F1ClaimCount.jun23,
    //     pro6F2ClaimCount.jun23,
    //     pro6F3ClaimCount.jun23
    // ]
    // export const pro6WithJun23PerVisit = [
    //     pro6F1PerVisit.jun23,
    //     pro6F2PerVisit.jun23,
    //     pro6F3PerVisit.jun23
    // ]
    // // jul 23
    // export const pro6WithJul23Charges = [
    //     pro6F1Charge.jul23,
    //     pro6F2Charge.jul23,
    //     pro6F3Charge.jul23
    // ]
    // export const pro6WithJul23Pay = [
    //     pro6F1Payment.jul23,
    //     pro6F2Payment.jul23,
    //     pro6F3Payment.jul23
    // ]
    // export const pro6WithJul23Count = [
    //     pro6F1Collectable.jul23,
    //     pro6F2Collectable.jul23,
    //     pro6F3Collectable.jul23
    // ]
    // export const pro6WithJul23NonCount = [
    //     pro6F1NonCollectable.jul23,
    //     pro6F2NonCollectable.jul23,
    //     pro6F3NonCollectable.jul23
    // ]
    // export const pro6WithJul23Claim = [
    //     pro6F1ClaimCount.jul23,
    //     pro6F2ClaimCount.jul23,
    //     pro6F3ClaimCount.jul23
    // ]
    // export const pro6WithJul23PerVisit = [
    //     pro6F1PerVisit.jul23,
    //     pro6F2PerVisit.jul23,
    //     pro6F3PerVisit.jul23
    // ]
    // // aug 23
    // export const pro6WithAug23Charges = [
    //     pro6F1Charge.aug23,
    //     pro6F2Charge.aug23,
    //     pro6F3Charge.aug23
    // ]
    // export const pro6WithAug23Pay = [
    //     pro6F1Payment.aug23,
    //     pro6F2Payment.aug23,
    //     pro6F3Payment.aug23
    // ]
    // export const pro6WithAug23Count = [
    //     pro6F1Collectable.aug23,
    //     pro6F2Collectable.aug23,
    //     pro6F3Collectable.aug23
    // ]
    // export const pro6WithAug23NonCount = [
    //     pro6F1NonCollectable.aug23,
    //     pro6F2NonCollectable.aug23,
    //     pro6F3NonCollectable.aug23
    // ]
    // export const pro6WithAug23Claim = [
    //     pro6F1ClaimCount.aug23,
    //     pro6F2ClaimCount.aug23,
    //     pro6F3ClaimCount.aug23
    // ]
    // export const pro6WithAug23PerVisit = [
    //     pro6F1PerVisit.aug23,
    //     pro6F2PerVisit.aug23,
    //     pro6F3PerVisit.aug23
    // ]
    // // sep 23
    // export const pro6WithSep23Charges = [
    //     pro6F1Charge.sep23,
    //     pro6F2Charge.sep23,
    //     pro6F3Charge.sep23
    // ]
    // export const pro6WithSep23Pay = [
    //     pro6F1Payment.sep23,
    //     pro6F2Payment.sep23,
    //     pro6F3Payment.sep23
    // ]
    // export const pro6WithSep23Count = [
    //     pro6F1Collectable.sep23,
    //     pro6F2Collectable.sep23,
    //     pro6F3Collectable.sep23
    // ]
    // export const pro6WithSep23NonCount = [
    //     pro6F1NonCollectable.sep23,
    //     pro6F2NonCollectable.sep23,
    //     pro6F3NonCollectable.sep23
    // ]
    // export const pro6WithSep23Claim = [
    //     pro6F1ClaimCount.sep23,
    //     pro6F2ClaimCount.sep23,
    //     pro6F3ClaimCount.sep23
    // ]
    // export const pro6WithSep23PerVisit = [
    //     pro6F1PerVisit.sep23,
    //     pro6F2PerVisit.sep23,
    //     pro6F3PerVisit.sep23
    // ]
    // // oct 23
    // export const pro6WithOct23Charges = [
    //     pro6F1Charge.oct23,
    //     pro6F2Charge.oct23,
    //     pro6F3Charge.oct23
    // ]
    // export const pro6WithOct23Pay = [
    //     pro6F1Payment.oct23,
    //     pro6F2Payment.oct23,
    //     pro6F3Payment.oct23
    // ]
    // export const pro6WithOct23Count = [
    //     pro6F1Collectable.oct23,
    //     pro6F2Collectable.oct23,
    //     pro6F3Collectable.oct23
    // ]
    // export const pro6WithOct23NonCount = [
    //     pro6F1NonCollectable.oct23,
    //     pro6F2NonCollectable.oct23,
    //     pro6F3NonCollectable.oct23
    // ]
    // export const pro6WithOct23Claim = [
    //     pro6F1ClaimCount.oct23,
    //     pro6F2ClaimCount.oct23,
    //     pro6F3ClaimCount.oct23
    // ]
    // export const pro6WithOct23PerVisit = [
    //     pro6F1PerVisit.oct23,
    //     pro6F2PerVisit.oct23,
    //     pro6F3PerVisit.oct23
    // ]
    // // nov 23
    // export const pro6WithNov23Charges = [
    //     pro6F1Charge.nov23,
    //     pro6F2Charge.nov23,
    //     pro6F3Charge.nov23
    // ]
    // export const pro6WithNov23Pay = [
    //     pro6F1Payment.nov23,
    //     pro6F2Payment.nov23,
    //     pro6F3Payment.nov23
    // ]
    // export const pro6WithNov23Count = [
    //     pro6F1Collectable.nov23,
    //     pro6F2Collectable.nov23,
    //     pro6F3Collectable.nov23
    // ]
    // export const pro6WithNov23NonCount = [
    //     pro6F1NonCollectable.nov23,
    //     pro6F2NonCollectable.nov23,
    //     pro6F3NonCollectable.nov23
    // ]
    // export const pro6WithNov23Claim = [
    //     pro6F1ClaimCount.nov23,
    //     pro6F2ClaimCount.nov23,
    //     pro6F3ClaimCount.nov23
    // ]
    // export const pro6WithNov23PerVisit = [
    //     pro6F1PerVisit.nov23,
    //     pro6F2PerVisit.nov23,
    //     pro6F3PerVisit.nov23
    // ]










